import { EMPTY_STRING, messages, UNDEFINED } from "../constants";

export function setItemToStorage(keyname, value) {
  return localStorage.setItem(keyname, value);
}

export function getItemFromStorage(keyname) {
  return localStorage.getItem(keyname);
}

export function removeItemFromStorage(keyname) {
  return localStorage.removeItem(keyname);
}

export function clearStorage() {
  return localStorage.clear();
}

export const saveToLocalStorage = (key, value) => {
  if (typeof window !== UNDEFINED) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      if (
        e.name === "QuotaExceededError" ||
        e.name === "NS_ERROR_DOM_QUOTA_REACHED"
      ) {
        console.warn(messages.LOCAL_STORAGE_WARNING, key);
      } else {
        console.error(messages.ERROR_SAVING_LOCAL_STORAGE, e);
      }
    }
  }
};

export const getLocalStorageItem = (key, defaultValue = EMPTY_STRING) => {
  if (typeof window === UNDEFINED) return defaultValue;

  const stored = localStorage.getItem(key);
  try {
    return stored ? JSON.parse(stored) : defaultValue;
  } catch (e) {
    console.warn(`${messages.FAILED_TO_PARSE_LOCAL_STORAGE} "${key}":`, e);
    return defaultValue;
  }
};
